/**
 * Membership Form Handler
 * Handles the membership form submission for both the cart page and the cart drawer.
 *
 * Cart page form (#membership-form) reloads the page on success.
 * Drawer form (#drawer-membership-form) refreshes the mini-cart section on success.
 * Drawer toggle/discard buttons use event delegation since the drawer is lazy-loaded.
 */

// =========================================================
// Cart Page: bind on DOMContentLoaded (form exists in DOM)
// =========================================================
document.addEventListener('DOMContentLoaded', () => {
  const membershipForm = document.getElementById('membership-form');
  const addMembershipBtn = document.getElementById('add-membership-btn');

  if (!membershipForm || !addMembershipBtn) return;

  membershipForm.addEventListener('submit', function(e) {
    e.preventDefault();
    submitMembership(addMembershipBtn, { reloadPage: true });
  });
});

// =========================================================
// Cart Drawer: event delegation (drawer is lazy-loaded)
// =========================================================

// Drawer add button click
document.addEventListener('click', function(e) {
  const addBtn = e.target.closest('#drawer-add-membership-btn');
  if (!addBtn) return;
  submitMembership(addBtn, { reloadPage: false });
});

// =========================================================
// Shared helpers
// =========================================================

/**
 * Add the membership product to cart and either reload the page
 * (cart page) or refresh the mini-cart drawer.
 */
function submitMembership(btn, { reloadPage }) {
  btn.disabled = true;
  btn.classList.add('is-loading');
  btn.innerHTML = '<span class="loading-spinner"></span> Adding...';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: [{
        id: 50836855783725,
        quantity: 1,
        properties: { 'Membership Type': 'Rescue Circle - Annual' }
      }]
    })
  })
  .then(response => {
    if (!response.ok) throw new Error('Network response was not ok');
    return response.json();
  })
  .then(() => {
    if (reloadPage) {
      showMessage('Membership added to your cart!', 'success', btn.closest('form'));
      setTimeout(() => window.location.reload(), 1000);
    } else {
      refreshMiniCart();
    }
  })
  .catch(error => {
    btn.disabled = false;
    btn.classList.remove('is-loading');
    btn.innerHTML = reloadPage ? 'ADD MEMBERSHIP TO BAG' : 'ADD TO BAG';
    if (reloadPage) {
      showMessage('Failed to add membership to cart. Please try again.', 'error', btn.closest('form'));
    }
    console.error('Error adding membership to cart:', error);
  });
}

/**
 * Re-fetch the mini-cart, cart icon bubble, and mobile cart icon bubble
 * sections simultaneously and update all three without a full page reload.
 */
function refreshMiniCart() {
  fetch('/?sections=mini-cart,cart-icon-bubble,mobile-cart-icon-bubble')
    .then(r => {
      if (!r.ok) throw new Error('sections fetch failed');
      return r.json();
    })
    .then(sections => {
      function applySectionHTML(elementId, sectionHTML) {
        const el = document.getElementById(elementId);
        if (!el || !sectionHTML) return;
        const parsed = new DOMParser().parseFromString(sectionHTML, 'text/html');
        const inner = parsed.querySelector('.shopify-section');
        if (inner) el.innerHTML = inner.innerHTML;
      }

      applySectionHTML('mini-cart', sections['mini-cart']);
      applySectionHTML('cart-icon-bubble', sections['cart-icon-bubble']);
      applySectionHTML('mobile-cart-icon-bubble', sections['mobile-cart-icon-bubble']);

      document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
    })
    .catch(() => window.location.reload());
}

/**
 * Show an inline success/error message inside a form (cart page only).
 */
function showMessage(message, type, form) {
  if (!form) return;
  let messageContainer = form.querySelector('.membership-message');
  if (!messageContainer) {
    messageContainer = document.createElement('div');
    messageContainer.className = 'membership-message';
    form.appendChild(messageContainer);
  }
  messageContainer.textContent = message;
  messageContainer.className = `membership-message ${type}`;
  messageContainer.style.display = 'block';
  messageContainer.style.color = type === 'success' ? '#28a745' : '#dc3545';
  setTimeout(() => { messageContainer.style.display = 'none'; }, 5000);
}
